// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"219da5a1","832":"b1a70e26"}[chunkId] + ".chunk.js";
};